import { render, staticRenderFns } from "./CoworkingApply.vue?vue&type=template&id=642103fa"
import script from "./CoworkingApply.vue?vue&type=script&lang=js"
export * from "./CoworkingApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports